import asyncActionTypes from '../actions/types.js';
import _ from 'lodash';

export const TOASTER_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
};

const MAX_MESSAGES = 3;

const initialState = {
  messages: [],
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.TOAST_QUEUE: {
      let { messages } = state;
      if (action.payload?.queue) {
        const maxMessages = action.payload?.maxMessages || MAX_MESSAGES;
        if (maxMessages <= messages.length) {
          messages = messages.slice(messages.length - maxMessages + 1, messages.length);
        }
        return {
          ...state,
          messages: [...messages, { ...action.payload, id: _.uniqueId('toast') }],
        };
      }
      return {
        ...state,
        messages: [{ ...action.payload, id: _.uniqueId('toast') }],
      };
    }
    case asyncActionTypes.TOAST_REMOVE: {
      let { messages } = state;
      const id = action?.id;
      if (id) {
        messages = messages.filter((message) => message?.id !== id);
      } else {
        messages.shift();
      }
      return {
        ...state,
        messages,
      };
    }
    default:
      return state;
  }
};

export default toastReducer;
